module.exports = __webpack_public_path__ + "img/ban_back.408a3ab1.jpg";